/* eslint-disable */
// (AUTO-GENERATED PAGE BUNDLE)
// PAGE NAME: comments-pinboard-page
// ==============================
import 'build/Y52yQKWtdSFEM1psite/sass/core.scss'
import * as commandQueue from 'init/command-queue'
import globalStore from 'init/global-store'
import { checkTurntoflow } from 'email-flows/turntoflow-check'
import { loadConfig as loadGlobalConfig } from 'init/global.config'
import loadIcons from 'util/browser/load-icons'
import { loadMessages } from 'services/msg'
import * as commentsPinboardLoader from 'widgets/comments-pinboard/comments-pinboard-loader'
import tokenService from 'services/token-service'
import { turnToConfig } from 'init/config'
import waitForValue from 'util/wait-for-value'

if (turnToConfig.sku) {
  globalStore.sku = turnToConfig.sku
}

function loadConfig(config) {
  // design editor inserts the icons to handle dynamic changes to icons
  if (!process.env.forThemer) {
    loadIcons(config.svg)
  }
  loadMessages(config.messages, config.pluralRuleFn)
  loadGlobalConfig(config.globalConfig)
  Promise.all([
    commentsPinboardLoader.loadWidget(config.commentsPinboard)
  ]).then(() => {
    globalStore.loaders = [
      commentsPinboardLoader
    ]
    commandQueue.init()
  })
  tokenService.loadLoggedInUser()
  checkTurntoflow()
}

// design editor may manipluate the config based on user inputs.  Need to make those changes before the widgets load.
// This allows the widgets to kick-off the loading once the configuration is ready.
if (process.env.forThemer) {
  // window.TurnTo defined in turnto.js
  window['TurnTo'].loadConfig = loadConfig
} else {
  waitForValue(() => window.TurnToPageConfig).then(() => {
    loadConfig(window.TurnToPageConfig)
  })
}
